export default "__VITE_ASSET__844bd06f__"